import { sendHTTPRequest } from '@/util/http'
import { goalbookUrls } from '@/util/links'

export interface GoalCharacteristic {
  Uuid: string
  Label: string
}

export async function getGoalCharacteristics(): Promise<GoalCharacteristic[]> {
  const response = await sendHTTPRequest({ url: `${goalbookUrls.pathwaysApi}/goal_characteristics`, includeCredentials: true })
  return await response.json() as GoalCharacteristic[]
}

export function characteristicLabelForUuid(characteristics: GoalCharacteristic[], uuid: string | undefined): string | undefined {
  return characteristics.find((characteristic) => characteristic.Uuid === uuid)?.Label
}
